import axios from 'axios';
import SessionManager from '@/Manager/Session.manager';
import KeyBoardManager from '@/Manager/keyboard.manager';
import PostApi from '@/scripts/api/post.api.js';
import Config from '@/scripts/config.js';
export default {
    name: 'giphy-search',
    data() {
        return {
            search: '',
            gifResults: [],
            limit: 10,
            offset: 0,
            leaps: 10,
            switchSearch: 'gifs', // stickers
            apiKey: Config.GIPHY_API_KEY,
            searchEndPoint: 'https://api.giphy.com/v1/gifs/search?',
            trendingEndPoint: 'https://api.giphy.com/v1/gifs/trending?',
            poweredByGiphy: `${process.env.BASE_URL}img/PoweredBy_200px-White_HorizText.png`,
            url: '',
            debouncer: null,
            trendingDebouncer: null,
            debounceInterval: 400
        }
    },
    mounted() {
        this.requestTrending();
        document.getElementById('search_results').addEventListener('scroll', e => {
            var element = e.target;
            if (element.offsetHeight + element.scrollTop === element.scrollHeight) {
                // Bottom
                this.offset += this.leaps;
                this.loadGifs();
            }
        });


    },
    watch: {
        search(value) {
            this.gifResults = [];
            this.offset = 0;
            this.loadGifs();
        },
        switchSearch(value) {
            this.gifResults = [];
            this.offset = 0;
            this.searchEndPoint = `https://api.giphy.com/v1/${value}/search?`;
            this.trendingEndPoint = `https://api.giphy.com/v1/${value}/trending?`;
            this.loadGifs();
        }
    },
    methods: {
        getGifs() {
            axios.
            get(this.url).
            then(res => {
                if (res.data.data.length > 0) {
                    let results = res.data.data
                        .map(gif => gif.id)
                        .map(gifId => {
                            return `https://media.giphy.com/media/${gifId}/giphy.gif`;
                        });
                    this.gifResults = this.gifResults.concat(results);
                }
            })
        },
        loadGifs() {
            if (this.search) {
                this.requestSearch();
            } else {
                this.requestTrending();
            }
        },
        requestSearch() {
            if (!this.debouncer) {
                this.debouncer = this.$_.debounce(() => {
                    this.url = `${this.searchEndPoint}&api_key=${this.apiKey}&q=${
                        this.search
                    }&limit=${this.limit}&offset=${this.offset}`;
                    this.getGifs();
                }, this.debounceInterval);
            }
            this.debouncer();
        },
        requestTrending() {
            if (!this.trendingDebouncer) {
                this.trendingDebouncer = this.$_.debounce(() => {
                    this.url = `${this.trendingEndPoint}&api_key=${this.apiKey}&limit=${this.limit}&offset=${this.offset}`;
                    this.getGifs();
                }, this.debounceInterval);
            }
            this.trendingDebouncer();
        },
        sendPost(gif) {
            console.log('gif', gif);
            let post = {
                origin: gif,
                type: 'gif',
                channel_id: SessionManager.getActiveChannelId()
            }
            PostApi.tryToFeedMessage(post);
        },
        allowWrite() {
            // There is a function in KeyboardManager --> onkeydown
            // TextareaManager.MoveCursorAfterAdd that remove the focus of the input
            // and doesn't allow to write
            KeyBoardManager.disableChatMode();
        },
        close() {
            this.$emit('close', true);
        }
    }
}
